import React from 'react';
import dayjs from "dayjs";
import {ITask} from "../../ModelContracts";
import useFormattedDate from "../../hooks/useFormattedDate/useFormattedDate";

interface IProps {
	task: ITask
}

const modeClassMap: Record<string, string> = {
	danger: 'badge-error',
	warning: 'badge-warning',
	secondary: 'badge-neutral',
};

function TaskStatus({ task } : IProps) {
	const [formattedDate] = useFormattedDate(task.dueDate);

	const getMode = () => {
		const currentDate = dayjs().startOf('day');
		const providedDate = dayjs(task.dueDate);
		if(providedDate < currentDate) return 'danger';
		if(providedDate.subtract(1, 'week') < currentDate) return 'warning';
		return 'secondary';
	};

	if(task.isComplete) return <span className="badge badge-success status" role="status" aria-label="Done">Done</span>;
	if(!task.dueDate) return <></>;
	return (
		<span className={`badge ${modeClassMap[getMode()]} due-date status`} aria-label="Due Date">
			<span role="status" aria-label={`Due: ${formattedDate}`}>{`Due: ${formattedDate}`}</span>
		</span>
	);
}

export default TaskStatus;
